var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLockedComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 33H20V33.5C20 34.8807 18.8807 36 17.5 36C16.6716 36 16 36.6719 16 37.5C16 38.3281 16.6716 39 17.5 39H30.5C31.3284 39 32 38.3281 32 37.5C32 36.9648 31.7191 36.4941 31.2966 36.2285C31.0658 36.084 30.7927 36 30.5 36C29.1193 36 28 34.8807 28 33.5V33Z",
    fill: "url(#paint0_linear_3708_7091)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25 19V18C25 17.4477 24.5523 17 24 17C23.4477 17 23 17.4477 23 18V19H25Z",
    fill: "url(#paint1_linear_3708_7091)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.5C8 12.0147 10.0147 10 12.5 10H35.5C37.9853 10 40 12.0147 40 14.5V27.5C40 29.9853 37.9853 32 35.5 32H12.5C10.0147 32 8 29.9853 8 27.5V14.5ZM22 19H21.5C20.9477 19 20.5 19.4477 20.5 20V24C20.5 24.5523 20.9477 25 21.5 25H26.5C27.0523 25 27.5 24.5523 27.5 24V20C27.5 19.4477 27.0523 19 26.5 19H26V18C26 16.8954 25.1046 16 24 16C22.8954 16 22 16.8954 22 18V19Z",
    fill: "url(#paint2_linear_3708_7091)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3708_7091",
    x1: 16,
    y1: 33,
    x2: 19.7821,
    y2: 43.4303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3708_7091",
    x1: 8,
    y1: 10,
    x2: 27.6775,
    y2: 40.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3708_7091",
    x1: 8,
    y1: 10,
    x2: 27.6775,
    y2: 40.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5D5D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#909090"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockedComputer);
export default __webpack_public_path__ + "static/media/LockedComputer.cbce4d23d4b3d0149a06633740750b49.svg";
export { ForwardRef as ReactComponent };